import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard, AccessDeniedComponent } from './core';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'account/mine',
        pathMatch: 'full'
    },
    {
        path: 'account',
        loadChildren: () => import('./merchant-account/merchant-account.module').then(m => m.MerchantAccountModule),
        canActivate: [RoleGuard],
        data: { roles: ['BasicUser'] }
    },
    {
        path: 'merchant-profiles',
        loadChildren: () => import('./merchant-profile/merchant-profile.module').then(m => m.MerchantProfileModule),
        canActivate: [RoleGuard],
        data: { roles: ['Admin'] }
    },
    {
        path: 'access-denied',
        component: AccessDeniedComponent
    },
    {
        path: '**',
        redirectTo: 'account'
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
